// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
/** Whether the browser tab is shown; polling stops while it is hidden. */
export function usePageVisible() {
    var _a = useState(function () { return document.visibilityState !== "hidden"; }), visible = _a[0], setVisible = _a[1];
    useEffect(function () {
        var update = function () { return setVisible(document.visibilityState !== "hidden"); };
        document.addEventListener("visibilitychange", update);
        return function () { return document.removeEventListener("visibilitychange", update); };
    }, []);
    return visible;
}
